import HotelFromApi from '../../types/HotelFromApi';

export type Hotel = HotelFromApi & {
  id: NonNullable<HotelFromApi['id']>;
  name: NonNullable<HotelFromApi['name']>;
};

export type HotelForSearchMap = {
  id: NonNullable<HotelFromApi['id']>;
  name: NonNullable<HotelFromApi['name']>;
  address: NonNullable<HotelFromApi['address']>;
  accessSimple: NonNullable<HotelFromApi['accessSimple']>;
  partnershipLevel: NonNullable<HotelFromApi['partnershipLevel']>;
  webCampaigns: NonNullable<HotelFromApi['webCampaigns']>;
  photos?: {
    selectedPhotos: NonNullable<HotelFromApi['photos']>['selectedPhotos'];
  };
};

export const isValidHotel = (h: HotelFromApi): h is Hotel => {
  return !!h.id && !!h.name;
};

export const isValidHotelForSearchMap = (h: HotelForSearchMap) => {
  return (
    !!h.id &&
    !!h.name &&
    !!h.address?.latitude &&
    !!h.address?.longitude &&
    !!h.accessSimple &&
    !!h.partnershipLevel &&
    !!h.photos?.selectedPhotos
  );
};
